// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ResetButton {
    background-color: #03b4c6;
    color: white;
    font-weight: bold;
    border-radius: 3vh;
    width: 50%;
    padding: 2vh;
    font-size: large;
    cursor: pointer;
    border: none;
  }
  
  .ResetButton:hover {
    background-color: white;
    color: #03b4c6;
    border: 2px solid #03b4c6; /* Add red border on hover */
  }
  `, "",{"version":3,"sources":["webpack://./src/MyComponents/ResetPassword/ResetPwPopup.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,cAAc;IACd,yBAAyB,EAAE,4BAA4B;EACzD","sourcesContent":[".ResetButton {\n    background-color: #03b4c6;\n    color: white;\n    font-weight: bold;\n    border-radius: 3vh;\n    width: 50%;\n    padding: 2vh;\n    font-size: large;\n    cursor: pointer;\n    border: none;\n  }\n  \n  .ResetButton:hover {\n    background-color: white;\n    color: #03b4c6;\n    border: 2px solid #03b4c6; /* Add red border on hover */\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
